import React from "react";
import { cn } from "../../lib/cn";

const PageHero = ({ title, subtitle, image, heightClass = "h-[56vh]" }) => {
  // Use proxy for Google Drive images to avoid CORS issues
  const getImageUrl = (url) => {
    if (url && url.includes('drive.google.com')) {
      return `${process.env.REACT_APP_BACKEND_URL}/api/media/proxy?url=${encodeURIComponent(url)}`;
    }
    return url;
  };

  return (
    <section
      className={cn("relative flex items-center justify-center overflow-hidden", heightClass)}
    >
      {/* Background Image with Premium Cinematic Filter */}
      <div 
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${getImageUrl(image)})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "saturate(1.2) contrast(1.1) brightness(0.92)",
        }}
      />
      
      {/* Premium gradient overlay with warmth */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/40 to-black/80" />
      
      {/* Subtle golden accent for luxury feel */}
      <div className="absolute inset-0 bg-gradient-to-tr from-[#C9A227]/10 via-transparent to-transparent" />
      
      {/* Cinematic vignette */}
      <div 
        className="absolute inset-0 pointer-events-none"
        style={{ boxShadow: "inset 0 0 150px 50px rgba(0,0,0,0.4)" }}
      />
      
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center text-white">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-wide drop-shadow-lg">
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-4 text-base md:text-lg text-white/85 drop-shadow-md">{subtitle}</p>
        ) : null}
      </div>
    </section>
  );
};

export default PageHero;
